export default "__VITE_ASSET__DoQHfq2i__"